import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';
import { ProductTypesResponseModel } from 'src/app/shared/api-models/responses/products/ProductTypesResponseModel';

/**
 * گرفتن اطلاعات کاربر
 */
@Injectable({
  providedIn: 'root'
})
export class GetProductTypesService {
  constructor(private baseClient: BaseHttpClientService) { }

  call() {
    let res = this.baseClient.getWithAuth<ProductTypesResponseModel>(

      `/api/v1/lesson/get_ProductTypes`
    );

    return res;
  }
}
